<template>
  <b-card
      header-tag="header"
      footer-tag="footer"
      img-alt="Image"
      img-top
      tag="article"
      style="height: 100%; width: 100%; cursor:move; border-radius: 15px; padding-left: 10px"
      class="mb-2"
  >
    <b-row>
      <b-col cols="3">
        <b-avatar
            @click="handleIconClick"
            :src="resourceImgURL"
            rounded="lg"
            variant="warning"
        />
      </b-col>
      <b-col  cols="6">
        <h6>{{resourceName}}</h6>
      </b-col>
      <b-col>
        <b-icon
            @click="handleMenuClick"
            icon="three-dots-vertical"
            font-scale="1.5"
            class="float-right"
            style="cursor: pointer"
        />
        <transition name="fade">
          <b-list-group
              v-if="showMenu"
              class="menu-panel"
          >
            <b-list-group-item
                @click="handleMenuItemOpenTool"
                class="d-flex justify-content-between align-items-center"
            >
              Open
              <b-badge variant="warning" pill>
                14
              </b-badge>
            </b-list-group-item>

            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Share
              <b-badge variant="primary" pill>2</b-badge>
            </b-list-group-item>

            <b-list-group-item class="d-flex justify-content-between align-items-center">
              Hide
              <b-badge variant="primary" pill>1</b-badge>
            </b-list-group-item>
          </b-list-group>
        </transition>
      </b-col>
    </b-row>
    <hr />
    <radial-progress-bar
        :diameter="diameter"
        :completed-steps="completedSteps"
        :total-steps="totalSteps"
        :start-color="startColor"
        :stop-color="stopColor"
        :stroke-width="strokeWidth"
        :inner-stroke-width="innerStrokeWidth"
    >
      <p>Total steps: {{ totalSteps }}</p>
      <p>Completed steps: {{ completedSteps }}</p>
    </radial-progress-bar>
    <div v-if="false" id="chart" style="margin-top: 15px">
      <apex-chart
          :type="chartType"
          :diameter="diameter";
          width="100%"
          :options="plotOptions"
          :series="series"
          :key="refresh"
      />
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import RadialProgressBar from 'vue-radial-progress';
import ApexChart from "vue-apexcharts";
export default {
  name: "HeartBeat_Block",
  components: {
    ApexChart,
    RadialProgressBar
  },
  props: {
    resource: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({}),
    resourceName(){
      return this.resource && this.resource.name ? this.resource.name : 'Awesome App';
    },
    resourceImgURL(){
      return this.resource && this.resource.imgURL ? this.resource.imgURL : this.myAppImgURL;
    }
  },
  beforeMount() {

  },
  mounted() {

  },
  methods: {
    handleIconClick(){
      debugger;
      //this.$emit("icon-click", this.resource);
    },
    handleMenuClick(){
      debugger;
      this.showMenu= !this.showMenu;
    },
    handleMenuItemOpenTool(){
      this.$emit("icon-click", this.resource);
    }
  },
  data() {
    return {
      /** Progress Bar- move to display for block display options https://wyzantinc.github.io/vue-radial-progress/**/
      diameter: 200,  //diameter of the progress bar circle in pixel
      totalSteps: 10, //Total number of steps to complete progress bar.
      completedSteps: 5, //Number of completed steps in the progress bar.
      startColor: "rgba(239,179,22,0.78)", //The color of the leading edge of the progress bar gradient.
      stopColor: "rgba(239,179,22,0.78)", //The width of the progress bar.
      innerStrokeColor: 10, //The width of the background/inner circle.
      strokeWidth: 15, //The width of the progress bar.
      innerStrokeWidth:15, //The width of the background/inner circle.
      strokeLinecap: 'round', //The type of stroke linecap for circle.
      animateSpeed: 1000, //The amount of time in milliseconds to animate one step.
      fps: 60, //The frames per second that the animation should run.
      timingFunc: "linear", //The transition timing function to use for the CSS transition. See transition-timing-function.
      isClockwise: true, //Controls the direction of the progress bar.
      /** Progress Bar End **/
      showMenu:false,
      refresh: 1,
      chartType: "bar",
      plotOptions: {
        bar: {
          horizontal: true
        }
      },
      series: [
        {
          data: [
            {
              x: "14 Sept",
              y: 10
            },
            {
              x: "15 Sept",
              y: 18
            },
            {
              x: "16 Sept",
              y: 13
            },
          ],
          chartOptions: {
            chart: {
              width: "20%",
              height: "50",
              type: "donut",
              colors: ["#8F99FC", "#FF8C7D", "#F6F28B", "#65EA82"]
            },
            colors: ["#8F99FC", "#FF8C7D", "#F6F28B", "#65EA82"],
            dataLabels: {
              enabled: false
            },
            stroke: {
              width: 0
            },
            states: {
              hover: {
                filter: {
                  type: "lighten",
                  value: 0
                }
              }
            },
            responsive: [
              {
                breakpoint: 300,
                options: {
                  legend: {
                    position: "bottom"
                  },
                  chart: {
                    // width: 250,
                    // height: 400,
                  }
                }
              },
              {
                breakpoint: 510,
                options: {
                  chart: {
                    width: 250,
                    height: 400
                  },
                  legend: {
                    // show: false,
                    position: "bottom",
                    fontSize: "14px"
                  }
                }
              },
              {
                breakpoint: 370,
                options: {
                  chart: {
                    width: 210,
                    height: 400
                  },
                  legend: {
                    // show: false,
                    position: "bottom",
                    fontSize: "12px"
                  }
                }
              },
              {
                breakpoint: 319,
                options: {
                  chart: {
                    width: 200
                    // height: 400,
                  },
                  legend: {
                    // show: false,
                    position: "bottom",
                    fontSize: "12px"
                  }
                }
              }
            ],

            legend: {
              position: "right",
              offsetY: 0,

              height: 121,
              fontSize: "14px",
              fontFamily: "Nunito, sans-serif",
              fontWeight: 400,
              markers: {
                fillColors: ["#8F99FC", "#FF8C7D", "#F6F28B", "#65EA82"],
                customHTML: function() {
                  return '<span class="custom-marker"></span>';
                }
              },
              itemMargin: {
                horizontal: 5,
                vertical: 3
              }
              // fill: {
              // },
            }
          }
        }
      ]
    }
  }
};
</script>


<style lang="scss" scoped>
.menu-panel {
  z-index: 10;
  cursor: pointer;
  position: absolute;
  top: 40px;
  right: -25px;
  width: 205px;
}
</style>